import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M20 22v.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MailQuestion";
const MailQuestion = memo(themed(Icon));
export {
  MailQuestion
};
//# sourceMappingURL=mail-question.js.map
